import Dexie from "dexie";
// import { useLiveQuery } from "dexie-react-hooks";

const updateMeiningsDexie = async (data) => {
  const { fromLang, toLang, word, dict, enData } = data;
  const DbName = `Dict${fromLang.toLowerCase()}To${toLang.toLowerCase()}`;
  const db = new Dexie(DbName);
  db.version(1).stores({ words: "++id, word, dict,enData" });
  let editedData = { dict };
  if (enData && enData.length > 0) editedData["enData"] = enData;
  await db.words
    .where("word")
    .aboveOrEqual(word.toLowerCase())
    .modify(editedData);
};

const getMeiningsDexie = async (data) => {
  const { fromLang, toLang, word } = data;
  const DbName = `Dict${fromLang.toLowerCase()}To${toLang.toLowerCase()}`;
  const db = new Dexie(DbName);

  db.version(1).stores({ words: "++id, word, dict,enData" });
  const dict = await db.words
    .where("word")
    .equals(word.toLowerCase())
    .toArray();
  return dict;
};

const setMeiningsDexie = async (data) => {
  const { fromLang, toLang, word, dict, enData } = data;
  const DbName = `Dict${fromLang.toLowerCase()}To${toLang.toLowerCase()}`;
  const db = new Dexie(DbName);

  db.version(1).stores({ words: "++id, word, dict,enData" });
  let storeData = { dict };
  if (enData && enData.length > 0) storeData["enData"] = enData;
  let a = await db.words.add({ word: word.toLowerCase(), ...storeData });
};

// const getSubtitleStylesInfoDexie = async (data) => {
//   // const { fromLang, toLang, word,dict } = data
//   const DbName = `SubtitleStylesData`;
//   const db = new Dexie(DbName);

//   db.version(1).stores({ subtitleStylesData: "++id, data" });
//   const stylesData = await db.words
//     .where("subtitleStylesData")
//     .equals("data")
//     .toArray();
//   console.log("dexiemeiningsmeinings", stylesData);
//   // return dict
// };

export { getMeiningsDexie, setMeiningsDexie, updateMeiningsDexie };
